import { axios } from '@ori/axios';
import { getRequestHeaders } from "./getRequestHeaders";
import { getSafeUrl } from "./getSafeUrl";
export var fetchTranslations = async function fetchTranslations(language, tenant, staticApiUrl) {
  var _translations$languag;
  var path = "/personalBeautyStore/tenants/".concat(tenant, "/localization?lang=").concat(language);
  var url = getSafeUrl(path, staticApiUrl || window.location.origin);
  var _await$axios$get = await axios.get(url.toString(), {
      headers: getRequestHeaders(language, tenant)
    }),
    translations = _await$axios$get.data.Translations;
  return (_translations$languag = translations[language]) !== null && _translations$languag !== void 0 ? _translations$languag : {};
};